import { SelectorProvider } from "@/app/providers/selector_provider"
import { TrayProvider } from "@/app/providers/tray_provider"
import { IconContext } from "@phosphor-icons/react"
import dynamic from "next/dynamic"
import { ReactNode } from "react"
import "react-toastify/dist/ReactToastify.css"

// avoid SSR for Navbar and Sidebar to prevent hydration issues
const SidebarMenu = dynamic(
  () =>
    import("@/components/sidebar_menu/sidebar_menu").then(
      (mod) => mod.SidebarMenu
    ),
  { ssr: false }
)

const Navbar = dynamic(
  () => import("@/components/layouts/nav_bar").then((mod) => mod.Navbar),
  { ssr: false }
)

export function RootLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="font-OS xl:mx-auto xl:flex xl:justify-center">
        <SidebarMenu />
        <IconContext.Provider
          value={{
            className: "h-[1.15rem] w-[1.15rem] cursor-pointer",
            weight: "regular",
          }}>
          <div
            id="main"
            className="relative mb-2 xl:mb-0 xl:w-[880px] 2xl:w-[1200px] print:w-full">
            <SelectorProvider>
              <TrayProvider>{children}</TrayProvider>
            </SelectorProvider>
          </div>
        </IconContext.Provider>
        <Navbar />
      </div>
      <footer className="invisible fixed bottom-0 hidden w-full print:visible print:block"></footer>
    </>
  )
}
